import * as React from 'react';
import type { TContactParam } from '@cian/newbuilding-chat-component';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { closeBuilderChat, openBuilderChat } from '../../actions/builderChat';
import { getGaLabel } from '../../selectors/analytics';
import { getUser } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux/thunk';
import { trackOpenChat, trackSendMessageClick } from '../../utils/analytics';

export function useBuilderChat(placeType: string) {
  const dispatch: TThunkDispatch = useDispatch();
  const user = useSelector(getUser);
  const gaLabel = useSelector(getGaLabel);

  const openChatWithTracking = React.useCallback(
    (chatContact: TContactParam) => {
      trackOpenChat({ label: gaLabel, placeType });
      dispatch(openBuilderChat(chatContact));
    },
    [dispatch, gaLabel, placeType],
  );

  const openChat = React.useCallback(
    (chatContact: TContactParam) => {
      trackSendMessageClick({ label: gaLabel, placeType });

      if (!user.isAuthenticated) {
        dispatch(
          requestAuthentication({
            onSuccess: () => () => openChatWithTracking(chatContact),
            onCloseNoAuth: closeBuilderChat,
          }),
        );

        return;
      }

      openChatWithTracking(chatContact);
    },
    [dispatch, openChatWithTracking, gaLabel, placeType, user],
  );

  return { openChat };
}
